import { render, staticRenderFns } from "./DisplayOrderItems.vue?vue&type=template&id=21fff7fc&scoped=true"
import script from "./DisplayOrderItems.vue?vue&type=script&lang=js"
export * from "./DisplayOrderItems.vue?vue&type=script&lang=js"
import style0 from "./DisplayOrderItems.vue?vue&type=style&index=0&id=21fff7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fff7fc",
  null
  
)

export default component.exports